export enum TimerTypeEnum {
  nav = 'nav',
  toast = 'toast',
}
